<template>
  <q-page :padding="!rebitAccountId && $q.screen.gt.xs" class="docs-table" :style-fn="myTweak">
    <transaction-rebit-account
        :data-row="serverData.length ? [serverData[0].rebit_account] : []"
        v-if="rebit_account && ! rebitAccountId"
        class="q-mb-md"
    />

    <q-table
        :title="'Transactions ' + $t('transactions.menu.list')"
        ref="table"
        :data="serverData"
        :columns="columns"
        :filter="filter"
        row-key="id"
        :pagination.sync="serverPagination"
        :visible-columns="visibleColumns"
        :loading="loading"
        :selection="selection"
        :selected.sync="selectedRows"
        :rows-per-page-options="[10, 15, 30, 50, 100]"
        style="margin-bottom:80px"
        @request="all"
    >
      <template v-slot:top-selection="props" v-if="$auth.can('transactions.edit')">
        <q-btn color="negative" outline icon="fa fa-trash" :label="$t('delete')" class="q-mr-sm" @click="deleteRows"/>
        <q-btn color="secondary" outline icon="fa fa-edit" :label="$t('edit')" class="q-mr-sm"
               v-if="selectedRows.length === 1" @click="edit(selectedRows[0])"/>
        <q-btn color="pink-5" outline icon="fa fa-times" class="q-mr-sm" @click="selectedRows = []"/>
      </template>

      <template v-slot:top-right="props">
      	<q-btn outline :label="$t('refresh')" icon="fas fa-sync" color="primary" class="q-mr-sm" @click="all({pagination: serverPagination, filter})" :loading="loading">
			<template v-slot:loading>
		    <q-spinner-dots />
		  </template>
		</q-btn>
        <q-btn
              :outline="!is_filtered"
              color="black"
              :label="is_filtered ? 'Filtered' : 'Filter'"
              class="q-mr-sm"
              icon="fa fa-filter"
        >
            <q-menu>
                  <div class="row q-pa-md q-col-gutter-md" style="width: 300px">
                      <div class="col-12">
                          <q-input
                              :value="date_range.from ? date_range.from + ' | ' + date_range.to : ''"
                              dense
                              class="q-mr-sm"
                              color="primary"
                              label="Date range"
                              readonly
                          >
                              <template v-slot:append v-if="date_range.from" >
                                  <q-icon
                                      name="cancel"
                                      @click.stop="removeDateRangeFilter"
                                      class="cursor-pointer"
                                  />
                              </template>
                              <template v-slot:prepend>
                                  <q-icon name="event" class="cursor-pointer">
                                      <q-popup-proxy
                                          ref="qDateProxy"
                                          transition-show="scale"
                                          transition-hide="scale"
                                          @hide="all({ pagination: serverPagination, filter})"
                                      >
                                          <q-date
                                              v-model="selecting_range"
                                              range
                                              mask="YYYY-MM-DD"
                                          >
                                              <div class="row items-center justify-end">
                                                  <q-btn v-close-popup label="Set" color="primary" flat />
                                              </div>
                                          </q-date>
                                      </q-popup-proxy>
                                  </q-icon>
                              </template>
                          </q-input>
                      </div>
                      <div class="col-12" v-show="!rebitAccountId">
                          <q-select
                              v-model="currency"
                              label="Currency"
                              dense
                              options-dense
                              emit-value
                              map-options
                              :options="exchangeable_currencies"
                              option-value="acronym"
                              option-label="name"
                              color="primary"
                              :loading="loading && !exchangeable_currencies.length"
                              @input="all({ pagination: serverPagination, filter})"
                          />
                      </div>
                      <div class="col-12" v-show="!rebitAccountId">
                          <q-select
                              v-model="rebit_account"
                              label="Rebit's account"
                              dense
                              clearable
                              options-dense
                              emit-value
                              map-options
                              use-input
                              :options="filtered_rebit_accounts"
                              option-value="id"
                              option-label="label"
                              color="primary"
                              @input="all({pagination: serverPagination, filter: filter})"
                              @filter="filterRebitAccounts"
                          >
                              <template v-slot:option="scope">
                                  <q-item
                                      v-bind="scope.itemProps"
                                      v-on="scope.itemEvents"
                                      class="q-py-sm"
                                  >
                                      <q-item-section>
                                          <q-item-label>{{ scope.opt.label }}</q-item-label>
                                      </q-item-section>
                                  </q-item>
                              </template>
                          </q-select>
                      </div>
                      <div class="col-12">
                          <q-select
                              v-model="filtered_statuses"
                              multiple
                              dense
                              options-dense
                              :display-value="filtered_statuses.length === 9 ? 'Statuses' : 'Statuses (filtered)'"
                              emit-value
                              map-options
                              :options="statuses"
                              @blur="all({ pagination: serverPagination, filter})"
                              color="primary"
                          >
                              <template v-slot:option="{ itemProps, itemEvents, opt, selected, toggleOption }">
                                  <q-item
                                      v-bind="itemProps"
                                      v-on="itemEvents"
                                  >
                                      <q-item-section>
                                          <q-item-label v-html="opt.label" ></q-item-label>
                                      </q-item-section>
                                      <q-item-section side>
                                          <q-toggle :value="selected" @input="toggleOption(opt)" color="green"/>
                                      </q-item-section>
                                  </q-item>
                              </template>
                          </q-select>
                      </div>
                  </div>
             </q-menu>
        </q-btn>
        <q-input dense debounce="300" v-model="filter" :placeholder="$t('search')" class="q-mr-sm">
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
        <q-select
            v-model="visibleColumns"
            multiple
            dense
            options-dense
            :display-value="$q.lang.table.columns"
            emit-value
            map-options
            :options="columns"
            option-value="name"
            style="min-width: 150px;margin-right:10px"
            color="primary"
        />
      </template>

      <!-- START CUSTOM COLUMNS -->
        <template v-slot:body="props">
            <q-tr :props="props"
                  :statement="props.row.currentStatus = statuses.find(item => item.value === props.row.status)">
                <q-td auto-width :props="props">
                    <q-checkbox dense v-model="props.selected" />
                </q-td>
                <q-td key="id" :props="props">{{ props.row.id }}</q-td>
                <q-td key="transfer_reference" :props="props">
                    <div v-if="$auth.can('transfers.list') && props.row.transfer_reference">
                        <q-btn icon="fa fa-link" size="xs" color="info" round flat
                               @click.native="openURL('/transfers?q='+props.row.transfer_reference)"/>
                        {{ props.row.transfer_reference || '-'}}
                    </div>
                    <div v-else>{{ props.row.transfer_reference }}</div>
                </q-td>
                <q-td key="side" :props="props">{{props.row.side}}</q-td>
                <q-td key="rebit_account" :props="props">
                    {{ props.row.rebit_account ? props.row.rebit_account.description : '-' }}
                </q-td>
                <q-td key="amount" :props="props">
                    <currency-format
                        class="text-bold inline-block"
                        :class="{'text-positive': props.row.side === 'credit', 'text-negative': props.row.side === 'debit'}"
                        :value="props.row.amount"
                        :unit="props.row.currency.symbol"
                        :sign="props.row.side === 'credit' ? '+' : '-'"
                        :decimal-max-length="4"
                    />
                </q-td>
                <q-td key="payment_details" :props="props">{{props.row.payment_details}}</q-td>
                <q-td key="created_at" :props="props">
                    {{ props.row.created_at }}
                    <q-tooltip
                        anchor="top middle"
                        self="center middle"
                        content-class="bg-amber-2 text-black"
                        content-style="font-size: 13px"
                    >{{props.row.created_at_utc}} (UTC)</q-tooltip>
                </q-td>
                <q-td key="status" :props="props"><span :class="'text-'+props.row.currentStatus.color">{{ props.row.currentStatus.label }}</span></q-td>
                <q-td key="setting" :props="props" v-if="$auth.can('transactions.edit')">
                    <q-btn round size="sm" color="orange" icon="fa fa-edit" @click="edit(props.row)"/>&nbsp;
                    <q-btn round size="sm" color="red" icon="fa fa-trash" @click="deleteRow(props.row)"/>
                </q-td>
            </q-tr>
        </template>

        <template v-slot:bottom-row="props" v-if="serverData.length && (rebit_account || currency)">
            <tr>
                <td class="total-row-borders" colspan="11">
                    <q-list style="max-width: 400px">
                        <q-item class="q-py-sm text-body1 text-positive">
                            <q-item-section>
                                <q-item-label lines="1">Total credits:</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <currency-format
                                    class="text-bold inline-block text-positive"
                                    :value="total_credits"
                                    :unit="serverData[0].currency.symbol"
                                    :decimal-max-length="4"
                                    hide-white-spaces
                                />
                            </q-item-section>
                        </q-item>

                        <q-item class="q-py-sm text-body1 text-negative">
                            <q-item-section>
                                <q-item-label lines="1">Total debits:</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <currency-format
                                    class="text-bold inline-block text-negative"
                                    :value="total_debits"
                                    :unit="serverData[0].currency.symbol"
                                    :decimal-max-length="4"
                                    sign="-"
                                    hide-white-spaces
                                />
                            </q-item-section>
                        </q-item>

                        <q-separator inset="item" />

                        <q-item class="q-py-sm text-body1" :class="balance < 0 ? 'text-negative' : 'text-positive'">
                            <q-item-section>
                                <q-item-label lines="1">Balance</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <currency-format
                                    class="text-bold inline-block"
                                    :class="balance < 0 ? 'text-negative' : 'text-positive'"
                                    :value="balance"
                                    :unit="serverData[0].currency.symbol"
                                    :decimal-max-length="4"
                                    hide-white-spaces
                                />
                            </q-item-section>
                        </q-item>
                    </q-list>
                </td>
            </tr>
        </template>
      <!-- END CUSTOM COLUMNS -->
    </q-table>
  </q-page>
</template>

<script>
  import Transaction from '../models/Transaction.js'
  import {mapGetters, mapActions} from 'vuex'
  import TransactionRebitAccount from "Modules/RebitAccount/resources/components/TransactionRebitAccount.vue"
  import { openURL } from 'quasar'
  export default {
    name: 'History',
    props: {
        rebitAccountId: {
            type: Number,
            default: undefined
        },
        rebitAccountCurrency: {
            type: String,
            default: null
        }
    },
    computed: {
      ...mapGetters(['exchangeable_currencies', 'rebit_accounts', 'allRebitAccountsByCurrency']),
	  columns() {
        return [
            {name: 'id', required: true, label: this.$t('transactions.table_titles.id'), align: 'left', field: 'id', sortable: true},
            {name: 'transfer_reference', label: this.$t('transactions.table_titles.transfer_reference'), align: 'center', field: 'transfer_reference', sortable: false },
            {name: 'side', label: this.$t('transactions.table_titles.side'), align: 'left', field: 'side', sortable: false},
            {name: 'rebit_account', label: this.$t('transactions.table_titles.rebit_account'), align: 'left', field: 'rebit_account.number', sortable: false},
            {name: 'amount', label: this.$t('transactions.table_titles.amount'), align: 'right', field: 'amount', sortable: false},
            {name: 'payment_details', label: this.$t('transactions.table_titles.payment_details'), align: 'left', field: 'payment_details', sortable: false},
            {name: 'created_at', label: this.$t('transactions.table_titles.received_date'), align: 'left', field: 'created_at', sortable: false},
            {name: 'status', label: this.$t('transactions.table_titles.status'), align: 'left', field: 'status', sortable: true },
        ]
      },
      selecting_range: {
          get: function() {
              return this.date_range
          },
          set: function(value) {
              if(value && typeof value === 'string') {
                  this.date_range = {from: value, to: value}
              } else if(value && typeof value === 'object' && value.from) {
                  this.date_range = value
              } else {
                  this.date_range = {from: '', to: ''}
              }
          }
      },
      is_filtered() {
          return this.date_range.from || this.filtered_statuses.length !== 9 || this.rebit_account || this.currency
      },
      balance() {
          return (this.total_credits - this.total_debits).roundToX(4)
      },
      historyUrl() {
          let rebit_account = `rebit_account=${this.rebit_account ? this.rebit_account : ''}`
          let date_range = `date_range=${this.date_range.from},${this.date_range.to}`
          let currency = `currency=${this.currency ? this.currency : ''}`
          let statuses = `statuses=${this.filtered_statuses}`
          return `${rebit_account}&${date_range}&${statuses}&${currency}`
      },
    },
    data: () => ({
      separator: 'horizontal',
      filter: '',
      loading: false,
      serverPagination: {
        page: 1,
        sortBy: 'id',
        rowsPerPage: 100,
        descending: true,
        rowsNumber: 10 // specifying this determines pagination is server-side
      },
      visibleColumns: ['id', 'transfer_reference', 'side', 'rebit_account', 'amount', 'payment_details', 'transaction_method', 'created_at', 'status'],
      serverData: [],
      selection: 'none',
      selectedRows: [],
      statuses: [
          {label: 'Pending', value: 'pending', color: 'grey'},
          {label: 'Accepted', value: 'accepted', color: 'positive'},
          {label: 'Declined', value: 'declined', color: 'negative'},
          {label: 'Refunded', value: 'refunded', color: 'negative'},
          {label: 'Rejected', value: 'rejected', color: 'negative'},
          {label: 'Frozen', value: 'frozen', color: 'warning'},
          {label: 'Require AML document', value: 'require_aml_document', color: 'warning'},
          {label: 'Clarity around name mismatch', value: 'clarity_around_name_mismatch', color: 'warning'},
          {label: 'Unknown', value: 'unknown', color: 'grey-10'},
      ],
      rebit_account: undefined,
      filtered_statuses: ['pending', 'accepted', 'declined', 'refunded', 'rejected', 'frozen','require_aml_document', 'clarity_around_name_mismatch', 'unknown'],
      date_range: {from:'', to:''},
      currency: undefined,
      total_credits: 0,
      total_debits: 0,
      filtered_rebit_accounts: []
    }),
    methods: {
      openURL,
      ...mapActions(['set_currencies']),
      all({pagination, filter}) {
        this.loading = true
        Transaction.all(`${this.historyUrl}&sort=${pagination.sortBy}%7C${pagination.descending ? 'desc' : 'asc'}&page=${pagination.page}&per_page=${pagination.rowsPerPage}&filter=${filter}`, ({data, meta, total_credits, total_debits}) => {
          this.serverPagination = pagination
          // we also set (or update) rowsNumber
          this.serverPagination.rowsNumber = meta.total
          this.serverData = data
          this.total_credits = total_credits
          this.total_debits = total_debits
          this.loading = false
        }).catch(error => {
          this.$q.notify({
            message: error.data.error,
            color: 'negative',
            icon: 'fa fa-exclamation-triangle'
          })
          this.loading = false
        })
      },
      removeDateRangeFilter() {
          this.date_range = {from: '', to: ''}
          this.all({
              pagination: this.serverPagination,
              filter: this.filter
          })
      },
      edit(value) {
        this.$router.push({name: 'transactions.edit', params: {id: value.id}})
      },
      deleteRow(row) {
        this.selectedRows.push(row);
        this.deleteRows();
      },
      deleteRows() {
        this.$q.dialog({
          title: 'Delete information',
          message: 'Are your sure?',
          ok: 'Yes',
          cancel: 'No'
        }).onOk(() => {
          this.$q.loading.show()
          this.selectedRows.map((row) => {
            let transaction = new Transaction({id: row.id});
            transaction.destroy(() => {
              this.serverData = this.serverData.filter(record => record.id !== row.id);
              this.selectedRows = this.selectedRows.filter(member => member.id !== row.id);
              if(!this.selectedRows.length){
                this.$q.loading.hide()
              }
            }).catch(({data}) => {
              this.$q.notify(data.error)
              this.$q.loading.hide()
            })
          });
        }).onCancel(() => {
          this.$q.loading.hide()
        })
      },
      myTweak(offset) {
        return {minHeight: offset ? `calc(35vh - ${offset}px)` : '35vh'}
      },
      preload() {
        this.rebit_account = this.rebitAccountId
        this.all({
          pagination: this.serverPagination,
          filter: this.filter
        })
      },
      filterRebitAccounts(val, update, abort) {
        if (val === '') {
            update(() => {
                this.filtered_rebit_accounts = this.currency ? this.allRebitAccountsByCurrency(this.currency) : this.rebit_accounts
            })
            return
        }

        update(() => {
            const needle = val.toLowerCase()
            const accounts = this.currency ? this.allRebitAccountsByCurrency(this.currency) : this.rebit_accounts
            this.filtered_rebit_accounts = accounts.filter(account => account.label.toLowerCase().indexOf(needle) > -1)
        })
      },
    },
    beforeCreate() {
      if(! this.$auth.can('transactions.list')){
        this.$router.push({name: 'dashboard'})
      }
    },
    mounted() {
        if (! this.exchangeable_currencies.length) {
            this.loading = true
            this.set_currencies().then(() => {
                this.loading = false
                this.currency = this.rebitAccountCurrency || this.exchangeable_currencies[0].acronym
                this.preload()
            }).catch(() => {this.loading = false})
        } else {
            this.currency = this.rebitAccountCurrency || this.exchangeable_currencies[0].acronym
            this.preload()
        }
    },
    components: {TransactionRebitAccount}
  }
</script>
